import styled from "styled-components";

import { Page } from "@/components/layout/Page";
import { WidgetFrame } from "@/components/layout/WidgetFrame";
import { WidgetWithQueryParameters } from "@/components/layout/WidgetFrame/widget.types";
import { DateRangeWidget } from "@/components/widgets/selects/DateRangeWidget";
import { colSpan, height } from "@/components/widgets/widget.utils";
import { CriticalAlarmsPerAstronautPast12MonthsKPIWidget } from "@/pages/DashboardPage/fms/widgets/CriticalAlarmsPerAstronautPast12MonthsKPIWidget";
import { MilkingsKPIFulfillmentWidget } from "@/pages/DashboardPage/fms/widgets/MilkingsKPIFulfillmentWidget";

const TitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 2rem;

    @container page (max-width: ${({ theme }) => theme.breakpoints.xs}) {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
        margin-bottom: 1rem;
    }
`;

const StyledPickerWrapper = styled.div`
    width: 33%;

    @container page (max-width: ${({ theme }) => theme.breakpoints.sm}) {
        width: 50%;
    }

    @container page (max-width: ${({ theme }) => theme.breakpoints.xs}) {
        width: 100%;
    }
`;

type Props = WidgetWithQueryParameters<"dateTo" | "dateFrom"> & {
    setDateFrom: (date: string) => void;
    setDateTo: (date: string) => void;
};

const MilkingSection = (props: Props) => {
    const { queryParameters, setDateFrom, setDateTo } = props;

    return (
        <Page.Content.Section>
            <TitleWrapper>
                <Page.Content.Section.Title>Milking</Page.Content.Section.Title>
                <StyledPickerWrapper>
                    <DateRangeWidget
                        dateFrom={queryParameters.dateFrom as string}
                        dateTo={queryParameters.dateTo as string}
                        onDateFromChange={setDateFrom}
                        onDateToChange={setDateTo}
                    />
                </StyledPickerWrapper>
            </TitleWrapper>
            <Page.Content.Widgets>
                <WidgetFrame colSpan={colSpan.chartFull} height={height.chart}>
                    <MilkingsKPIFulfillmentWidget queryParameters={queryParameters} />
                </WidgetFrame>
                <WidgetFrame colSpan={colSpan.kpiHalf} height={height.kpi}>
                    <CriticalAlarmsPerAstronautPast12MonthsKPIWidget queryParameters={queryParameters} />
                </WidgetFrame>
            </Page.Content.Widgets>
        </Page.Content.Section>
    );
};

export { MilkingSection };
